import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import './Hamburger.css';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedin, FaYoutube } from 'react-icons/fa';
import 'react-phone-input-2/lib/style.css';
import PhoneInput from 'react-phone-input-2';
import AOS from 'aos';
import 'aos/dist/aos.css';

import { motion } from "framer-motion";


const Homepage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [inquiryOpen, setInquiryOpen] = useState(false);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [formStatus, setFormStatus] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    document.documentElement.style.overflowX = 'hidden';
    document.body.style.overflowX = 'hidden';
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleSidebar = () => setIsOpen(!isOpen);
  const toggleDropdown = (menu) =>
    setOpenDropdown(openDropdown === menu ? null : menu);
  const toggleInquiry = () => setInquiryOpen(!inquiryOpen);

  const interests = [
    'Renders',
    'Animation Film',
    'Branding',
    'Marketing',
    'Career',
  ];

  const toggleInterest = (item) => {
    setSelectedInterests((prev) =>
      prev.includes(item)
        ? prev.filter((i) => i !== item)
        : [...prev, item]
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const formData = {
      name: e.target[0].value,
      email: e.target[1].value,
      contact: e.target[2].value,
      message: e.target[3].value,
      interests: selectedInterests.join(', '),
    };

    fetch('http://localhost:5000/api/send-inquiry', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formData),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.success) setFormStatus('success');
        else setFormStatus('error');
      })
      .catch(() => setFormStatus('error'));

    setTimeout(() => {
      setFormStatus(null);
      e.target.reset();
    }, 3000);
  };

  return (
    <div className="relative bg-black text-white min-h-screen font-montserrat overflow-x-hidden">
      <Helmet>
        <title>Edge Pixel | Creative Studio</title>
        <meta
          name="description"
          content="Edge Pixel specializes in 3D renders, animation films, branding, and marketing to elevate your brand vision."
        />
        <meta
          name="keywords"
          content="Edge Pixel, 3D Renders, Animation, Branding, Marketing, Creative Studio"
        />
        <meta name="author" content="Edge Pixel" />
        <meta property="og:title" content="Edge Pixel | Creative Studio" />
        <meta
          property="og:description"
          content="Edge Pixel crafts stunning 3D renders, animation films, branding, and marketing."
        />
        <meta
          property="og:image"
          content="https://edgepixel.co.in/assets/cover.png"
        />
        <meta property="og:url" content="https://edgepixel.co.in" />
        <meta property="og:type" content="website" />
      </Helmet>

      {/* === Navbar === */}
      <nav
        className={`fixed w-full z-50 px-4 sm:px-6 md:px-12 py-5 transition-colors duration-300 ${
  scrolled ? 'bg-black/90' : 'bg-transparent'
}`}

      >
        <div className="flex justify-between items-center">
          <img
            src="/assets/LOGO.png"
            alt="Edge Pixel Logo"
            className="h-5 sm:h-8 md:h-6 lg:h-8 object-contain"
          />

          <div className="z-50">
            {!isOpen ? (
              <div className="hamburger" onClick={toggleSidebar}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            ) : (
              <button
                onClick={toggleSidebar}
                className="text-white text-3xl font-semibold transition-transform duration-300 transform hover:scale-125"
              >
                ✕
              </button>
            )}
          </div>
        </div>
      </nav>

      {/* === Sidebar === */}
      <aside
        className={`fixed top-0 right-0 h-full w-full md:w-[380px] bg-black/90 backdrop-blur-md text-white transform transition-transform duration-300 z-40 ${
          isOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <div className="pt-24 pb-10 px-4 sm:px-6 h-full w-full overflow-y-auto">
          <nav className="w-full max-w-[320px] mx-auto space-y-4">
            <ul className="space-y-2 font-montserrat text-sm">
              <li className="border-b border-gray-700 pb-2 cursor-pointer hover:text-gray-300">
                HOME
              </li>
              <div className="flex justify-between items-center border-b border-gray-700 pb-2 cursor-pointer hover:text-gray-300">
                <span>ABOUT</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-700 pb-2 cursor-pointer hover:text-gray-300">
                <span>SERVICES</span>
              </div>
              <li className="border-b border-gray-700 pb-2 cursor-pointer hover:text-gray-300">
                PORTFOLIO
              </li>
              <li className="border-b border-gray-700 pb-2 cursor-pointer hover:text-gray-300">
                BLOG
              </li>
              <li className="border-b border-gray-700 pb-2 cursor-pointer hover:text-gray-300">
                CONTACT
              </li>
            </ul>

            {/* Search box */}
            <div className="mt-6 mb-8">
              <p className="text-sm font-bold mb-2">SEARCH</p>
              <div className="flex items-center">
                <input
                  type="text"
                  placeholder="Search ..."
                  className="flex-1 px-3 py-[6px] bg-transparent text-white text-sm placeholder-white border border-gray-500 rounded-l-sm focus:outline-none"
                />
                <button className="px-4 py-[6px] text-sm text-white bg-transparent border border-white rounded-r-sm hover:text-gray-300">
                  SEARCH
                </button>
              </div>
            </div>

            {/* Outsourcing workplace */}
            <div className="mt-10 text-xs">
              <p className="mb-2 text-sm tracking-widest">
                Outsourcing workplace:
              </p>
              <p className="text-gray-500 mb-2">IND, UAE, USA, UK, CA</p>
              <div className="flex gap-2">
                <img src="/assets/IND.png" alt="India" className="h-4 w-6" />
                <img src="/assets/UAE.png" alt="UAE" className="h-4 w-6" />
                <img src="/assets/USA.png" alt="USA" className="h-4 w-6" />
                <img src="/assets/UK.png" alt="UK" className="h-4 w-6" />
                <img src="/assets/CA.png" alt="Canada" className="h-4 w-6" />
              </div>
            </div>

            {/* Social icons */}
            <div className="mt-6">
              <p className="text-xs font-semibold mb-2">FOLLOW US</p>
              <div className="flex gap-3">
                <a href="#"><FaInstagram className="text-gray-500 hover:text-white text-lg" /></a>
                <a href="#"><FaFacebookF className="text-gray-500 hover:text-white text-lg" /></a>
                <a href="#"><FaTwitter className="text-gray-500 hover:text-white text-lg" /></a>
                <a href="#"><FaLinkedin className="text-gray-500 hover:text-white text-lg" /></a>
                <a href="#"><FaYoutube className="text-gray-500 hover:text-white text-lg" /></a>
              </div>
            </div>

            <div className="mt-4 text-[10px] text-gray-500">
              &copy; 2023 | edgepixel.co.in
            </div>
          </nav>
        </div>
      </aside>

      {/* === Inquiry Form Sidebar === */}
      <aside
        className={`fixed ${
          inquiryOpen ? 'translate-x-0' : 'translate-x-full'
        } right-0 top-0 transition-transform duration-300 z-50 w-full h-screen sm:top-1/4 sm:h-[60vh] sm:w-80 bg-white text-black rounded-none sm:rounded-l-3xl overflow-y-auto shadow-lg`}
      >
        <div className="flex justify-end p-3">
          <button
            className="text-black text-xl font-bold"
            onClick={toggleInquiry}
          >
            ✕
          </button>
        </div>

        <div className="px-4 pb-6 text-sm">
          <h2 className="text-lg font-semibold mb-4">Work Inquiry</h2>

          <form className="space-y-2 text-sm" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Name*"
              className="w-full px-2 py-2 border rounded-md border-gray-300 text-sm focus:outline-none"
              required
            />
            <input
              type="email"
              placeholder="Email*"
              className="w-full px-2 py-2 border rounded-md border-gray-300 text-sm focus:outline-none"
              required
            />

            <div className="mb-2">
              <label
                htmlFor="phone"
                className="text-xs font-medium mb-1 block text-gray-600"
              >
                Contact*
              </label>
              <PhoneInput
                country={'in'}
                enableSearch={true}
                disableSearchIcon={true}
                placeholder="Enter phone number"
                inputProps={{ name: 'phone', required: true }}
                inputStyle={{
                  width: '100%',
                  height: '34px',
                  fontSize: '13px',
                  borderRadius: '6px',
                  border: '1px solid #ccc',
                  backgroundColor: '#f3f3f3',
                  color: '#000',
                }}
                dropdownStyle={{
                  zIndex: 9999,
                  maxHeight: '200px',
                  overflowY: 'auto',
                }}
              />
            </div>

            <textarea
              placeholder="Message*"
              className="w-full px-2 py-2 border border-gray-300 rounded-md text-sm"
              rows="3"
              required
            />

            <div className="mt-4">
              <p className="text-m font-medium mb-2 text-gray-600">
                I’m interested in
              </p>
              <div className="flex flex-wrap gap-2">
                {interests.map((item, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() => toggleInterest(item)}
                    className={`px-3 py-1.5 rounded-md text-xs font-medium border border-gray-300 ${
                      selectedInterests.includes(item)
                        ? 'bg-gray-500 text-white'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-300'
                    } transition duration-300`}
                  >
                    {item}
                  </button>
                ))}
              </div>
            </div>

            <div className="flex justify-start mt-4">
              <button
                type="submit"
                className="px-3 py-2 border border-gray-500 text-white rounded-md text-xs tracking-wide bg-black hover:bg-gray-500 hover:text-white transition duration-300"
              >
                SUBMIT
              </button>
            </div>
          </form>

          {formStatus === 'success' && (
            <p className="text-green-600 text-xs mt-2 font-medium">
              ✅ Thank you! Your inquiry has been submitted. We’ll get in touch
              shortly.
            </p>
          )}
          {formStatus === 'error' && (
            <p className="text-red-600 text-xs mt-2 font-medium">
              ❌ Something went wrong. Please try again later.
            </p>
          )}
        </div>
      </aside>

      {!isOpen && (
        <div
          className={`fixed top-1/2 z-50 transform -translate-y-1/2 transition-all duration-300 ${
            inquiryOpen ? 'sm:right-[322px] right-full' : 'right-0'
          }`}
        >
          <button
            onClick={toggleInquiry}
            className="bg-[#000000] text-white font-medium hover:bg-gray-700 shadow-lg inline-flex items-center justify-center rounded-l-xl w-8 sm:w-10 lg:w-12 h-28 sm:h-32 lg:h-40"
          >
            <span className="transform rotate-[-90deg] tracking-[0.3rem] text-[0.7rem] sm:text-[0.8rem] lg:text-[0.8rem] font-montserrat font-medium">
              INQUIRY
            </span>
          </button>
        </div>
      )}

      <main>
        {/* === Hero Section === */}
        <section className="relative w-full overflow-hidden h-screen">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="absolute top-0 left-0 w-full h-full object-cover"
          >
            <source src="/assets/Hero.mp4" type="video/mp4" />
          </video>

          <div className="absolute inset-0 bg-black/60 z-10 flex justify-between items-center px-4 sm:px-6 md:px-12">
            <div className="flex flex-col justify-center h-[112px] sm:h-[128px] lg:h-[160px]">
              <h1 className="max-w-[1000px] text-[18px] sm:text-[26px] md:text-[30px] lg:text-[34px] xl:text-[42px] font-thin font-montserrat mb-2 sm:mb-1 leading-tight tracking-wide text-white break-words">
                <span className="block sm:inline">We craft powerful</span>{' '}
                <span className="block sm:inline">experiences that elevate</span>{' '}
                <span className="block sm:inline">your vision and leave</span>{' '}
                <span className="block sm:inline">
                  a lasting impression.
                </span>
              </h1>

              <button className="border border-white px-4 sm:px-6 py-1.5 sm:py-2 text-xs sm:text-sm tracking-widest font-montserrat hover:bg-white hover:text-black transition w-fit mt-3">
                WORK HIGHLIGHTS
              </button>
            </div>
          </div>
        </section>

        {/* === About Section === */}
     <section
  id="about"
  className="min-h-screen w-full bg-white flex justify-center items-center px-4 sm:px-8 md:px-12 lg:px-24 xl:px-32 py-16"
>
  <div className="max-w-[1600px] w-full flex flex-col lg:flex-row gap-12">

    {/* LEFT - PHOTOS */}
    <div className="w-full lg:w-1/2 flex flex-col gap-4">

      {/* Top row - 2 images */}
      <div className="grid grid-cols-2 gap-4">
  <motion.div
    className="w-full aspect-[4/3] overflow-hidden shadow-md"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
  >
    <img
      src="/assets/office1.jpg"
      alt="Creative studio workspace with modern design elements"
      className="w-full h-full object-cover"
    />
  </motion.div>

  <motion.div
    className="w-full aspect-[4/3] overflow-hidden shadow-md"
    initial={{ opacity: 0, y: 30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6, delay: 0.2 }}
  >
    <img
      src="/assets/office2.jpg"
      alt="Modern office interior with contemporary furniture"
      className="w-full h-full object-cover"
    />
  </motion.div>
</div>

      {/* Bottom row - 3 images */}
      <div className="grid grid-cols-3 gap-4">
        <motion.img
          src="/assets/office3.jpg"
          alt="Interior design details highlighting texture and light"
          className="w-full h-[180px] object-cover shadow-md"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
        />
        <motion.img
          src="/assets/office4.jpg"
          alt="Creative studio decor and architectural elements"
          className="w-full h-[180px] object-cover shadow-md"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
        />
        <motion.img
          src="/assets/office5.jpg"
          alt="Architectural workspace with clean modern lines"
          className="w-full h-[180px] object-cover shadow-md"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.8 }}
        />
      </div>
    </div>

    {/* RIGHT - TEXT */}
    <motion.div
      className="w-full lg:w-1/2 text-gray-800 flex flex-col justify-start lg:mt-[0px] mt-4"
      initial={{ opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.8 }}
    >
      {/* align title with top images horizontally */}
      <h2 className="text-3xl md:text-4xl font-bold tracking-wide uppercase mb-6 text-gray-900 lg:mt-[0px]">
        About Us
      </h2>
      <p className="text-lg md:text-xl font-semibold mb-4 text-gray-900">
        We specialize in high-quality 3D architectural rendering and branding
        design services for architects, interior designers, real estate
        companies, and diverse industries.
      </p>
      <p className="text-gray-700 leading-relaxed mb-6">
        As a creative, globally connected studio, we deliver
        <strong> high-end 3D architectural visualization and branding solutions.</strong>{" "}
        Driven by innovation and a passion for design, we collaborate with
        architects, interior designers, real estate developers, and creative
        agencies worldwide to bring ideas to life through stunning,
        photorealistic visuals.{" "}
        <strong>
          We specialize in architectural visualization, photorealistic 3D
          rendering, branding, and design strategy <span> </span>
        </strong>and more.....
      </p>
      <motion.a
        href="#"
        className="inline-block border border-gray-900 w-[200px] text-center px-4 py-2 text-sm font-montserrat tracking-widest uppercase hover:bg-gray-900 hover:text-white transition-all duration-300"
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
      >
        Learn More
      </motion.a>
    </motion.div>
  </div>
</section>


     
      </main>
    </div>
  );
};

export default Homepage;
